import * as React from "react";
import { Path } from "react-native-svg";
import { Icon, IIconProps } from "native-base";

export const Password = (props: IIconProps) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <Path
      d="M18.53 21.5638C14.2256 22.1454 9.80992 22.1454 5.50555 21.5638C4.80873 21.4344 4.17186 21.1732 3.66009 20.807C3.14831 20.4407 2.78 19.9826 2.59281 19.4794C1.8024 16.3602 1.8024 13.1629 2.59281 10.0437C2.78341 9.54734 3.15057 9.09594 3.65758 8.73465C4.16459 8.37337 4.79366 8.11487 5.48187 7.98501C9.78737 7.41239 14.2008 7.41239 18.5063 7.98501C19.1954 8.10965 19.8268 8.36416 20.3363 8.72272C20.8458 9.08128 21.2152 9.53111 21.4072 10.0265C22.1976 13.1457 22.1976 16.3431 21.4072 19.4622C21.229 19.9663 20.8684 20.4267 20.3626 20.7961C19.8568 21.1656 19.2242 21.4306 18.53 21.5638V21.5638Z"
      stroke="currentColor"
      fill="transparent"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      d="M7.55554 7.55556V6.44444C7.55554 3.98984 9.54539 2 12 2V2C14.4546 2 16.4444 3.98984 16.4444 6.44444V7.55556"
      stroke="currentColor"
      fill="transparent"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <Path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.1112 15.6128C13.1112 15.2558 13.3147 14.9379 13.5677 14.6861C13.972 14.2837 14.2222 13.7266 14.2222 13.1111C14.2222 11.8838 13.2273 10.8889 12 10.8889C10.7727 10.8889 9.77777 11.8838 9.77777 13.1111C9.77777 13.7267 10.028 14.2838 10.4324 14.6862C10.6854 14.938 10.889 15.2559 10.889 15.6129V16.5556C10.889 17.1079 11.3367 17.5556 11.889 17.5556H12.1112C12.6635 17.5556 13.1112 17.1079 13.1112 16.5556V15.6128Z"
      fill="currentColor"
    />
    <Path
      d="M17.5556 15.3333C18.1682 15.3333 18.6667 14.8349 18.6667 14.2222C18.6667 13.6095 18.1682 13.1111 17.5556 13.1111C16.9429 13.1111 16.4445 13.5991 16.4445 14.2222C16.4445 14.8349 16.9429 15.3333 17.5556 15.3333Z"
      fill="currentColor"
    />
    <Path
      d="M6.44442 15.3333C7.05709 15.3333 7.55553 14.8349 7.55553 14.2222C7.55553 13.6095 7.05709 13.1111 6.44442 13.1111C5.83176 13.1111 5.33331 13.5991 5.33331 14.2222C5.33331 14.8349 5.83176 15.3333 6.44442 15.3333Z"
      fill="currentColor"
    />
  </Icon>
);

export default Password;
